import React from 'react'
import Xml from 'components/shared/Xml'
import { useSelector } from 'react-redux'
import selectIsLogged from 'redux/selectors/selectIsLogged'

const QaResultsItemExcerpt = ({ truncated, answer, xmlProps }) => {
  if (truncated) {
    return <hr /> // ?
  }

  const isLogged = useSelector(selectIsLogged)
  if (isLogged) {
    return <Xml render={answer} {...xmlProps} />
  }

  return <div style={{ width: '100%', height: '3rem' }} />
}

export default QaResultsItemExcerpt
